ClickElseWhereMixin = require 'mixins/click-else-where'

App.SortDropdownComponent = Em.Component.extend ClickElseWhereMixin,
  classNames: ['sort-dropdown']
  isShown: false

  onClickElsewhere: ->
    @set('isShown', false)

  click: ->
    @toggleProperty('isShown', true)
